import {combineReducers} from 'redux';
// @ts-expect-error
import {createReducer} from 'redux-act';

import type {ReportRowData, TimeseriesReportData} from 'nutshell-core/types';

import type {LandingPagesStats} from '../../reports/report-summary';

import * as actions from './pages-actions';

type LandingPagesReportTableData = {
    rows: ReportRowData[] | null | undefined;
    totals: ReportRowData | null | undefined;
    hasError: boolean;
};
type LandingPagesReportState = {
    timeseriesChart: {
        isLoading: boolean;
        isTimedOut: boolean;
        isErrored: boolean;
        chartData: TimeseriesReportData | null | undefined;
        prefix: string;
    };
    tableData: LandingPagesReportTableData;
};
const landingPagesReportDefaultState = {
    timeseriesChart: {
        isLoading: true,
        isTimedOut: false,
        isErrored: false,
        chartData: null,
        prefix: '$',
    },
    tableData: {rows: undefined, totals: undefined},
} as const;

const defaultStat = {value: 0, formatted: '0', prefix: '$', suffix: ''} as const;
const defaultPageSummaryStats: LandingPagesStats = {
    // @ts-expect-error
    views: {mean: defaultStat, sum: defaultStat},
};

type SummaryStatsState = {
    isLoading: boolean;
    stats: LandingPagesStats;
};
const summaryStatsDefaultState = {
    isLoading: true,
    stats: defaultPageSummaryStats,
} as const;

const landingPagesReportReducer = createReducer(
    {
        [actions.updateLandingPagesReportTableData]: (
            // @ts-expect-error
            state,
            payload: LandingPagesReportTableData
        ) => {
            return {...state, tableData: payload};
        },
        // @ts-expect-error
        [actions.requestLandingPagesReportData]: (state) => {
            const newChartState = {
                ...state.timeseriesChart,
                isLoading: true,
                isTimedOut: false,
                isErrored: false,
            } as const;

            const newTableState = {
                ...state.tableData,
                isLoading: true,
                isTimedOut: false,
                isErrored: false,
            } as const;

            return {...state, timeseriesChart: newChartState, tableData: newTableState};
        },
        // @ts-expect-error
        [actions.updateLandingPagesReportChartData]: (state, {chartData}) => {
            const newChartState = {
                ...state.timeseriesChart,
                isLoading: false,
                isTimedOut: false,
                isErrored: false,
                chartData,
            } as const;

            return {...state, timeseriesChart: newChartState};
        },
        // @ts-expect-error
        [actions.failLandingPagesReportChartData]: (state, err) => {
            if (err) {
                if (err.status === 504 || err.status === 502) {
                    const newChartState = {
                        ...state.timeseriesChart,
                        chartData: null,
                        isLoading: false,
                        isTimedOut: true,
                        isErrored: false,
                    } as const;

                    return {...state, timeseriesChart: newChartState};
                } else {
                    const newChartState = {
                        ...state.timeseriesChart,
                        chartData: null,
                        isLoading: false,
                        isTimedOut: false,
                        isErrored: true,
                    } as const;

                    return {
                        ...state,
                        tableData: {...state.tableData, hasError: true},
                        timeseriesChart: newChartState,
                    };
                }
            }

            return state;
        },
    },
    landingPagesReportDefaultState
);

export const summaryStatsReducer = createReducer(
    {
        // @ts-expect-error
        [actions.requestLandingPagesReportData]: (state) => {
            return {...state, isLoading: true};
        },
        // @ts-expect-error
        [actions.updateLandingPagesSummaryStats]: (state, {stats}) => {
            return {...state, isLoading: false, stats: stats};
        },
    },
    summaryStatsDefaultState
);

export const landingPagesReducer = combineReducers({
    landingPagesReport: landingPagesReportReducer,
    summaryStats: summaryStatsReducer,
});

export type LandingPagesState = {
    landingPagesReport: LandingPagesReportState;
    summaryStats: SummaryStatsState;
};
